export const ROLES = [
    "guest",
    "member",
    "partner_owner",
    "partner_staff",
    "member_manager",
    "partner_manager",
    "super_admin"
];
export const MEMBERSHIP_LEVELS = ["Basic", "Silver", "Gold", "VIP"];
export const PERMISSIONS = [
    "members:read",
    "members:create",
    "members:update",
    "members:delete",
    "members:block",
    "partners:read",
    "partners:create",
    "partners:update",
    "partners:delete",
    "partner:dashboard",
    "partner:check_card",
    "partner:create_redemption",
    "partner:edit_store",
    "partner:edit_discounts",
    "partner:edit_offers",
    "admin:roles",
    "admin:audit",
    "admin:stats"
];
export const ADMIN_ROLES = ["super_admin", "member_manager", "partner_manager"];
